/**
 * Free Shipping + Tiered Discount Bar
 * Understøtter tidsstyrede kampagner via data-campaigns (fx Black Days).
 */

if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const hasGiftcard = this.dataset.hasGiftcard === 'true';
      const giftcardNote = this.querySelector('.free-shipping--giftcard-note');

      if (giftcardNote) {
        giftcardNote.style.display = hasGiftcard ? 'block' : 'none';
      }

      this.remainingText = this.querySelector('.free-shipping--text-remaining');
      this.fullText = this.querySelector('.free-shipping--text-full');

      // Aktiv kampagne (fx Black Days) overstyrer standard-trappen
      const campaign = this.activeCampaign(this.parseJSON(this.dataset.campaigns));
      this.tiers = campaign && campaign.tiers && campaign.tiers.length
        ? campaign.tiers
        : this.parseJSON(this.dataset.tiers);

      this.update();
    }

    parseJSON(str) {
      try {
        return JSON.parse(str || '[]');
      } catch (e) {
        return [];
      }
    }

    // Første kampagne hvor nu ligger mellem start (inkl.) og end (ekskl.)
    activeCampaign(campaigns) {
      const now = Date.now();
      return campaigns.find(c => {
        const start = Date.parse(c.start);
        const end = Date.parse(c.end);
        return !isNaN(start) && !isNaN(end) && now >= start && now < end;
      });
    }

update() {
  if (!this.tiers.length) return;

  const total = Number(this.dataset.cartTotal || 0) / 100;

  const nextTier = this.tiers.find(t => total < t.amount);
  const achievedTier = [...this.tiers].reverse().find(t => total >= t.amount);
  const topTier = this.tiers[this.tiers.length - 1];

  let percentage = 1;

  if (!this.remainingText || !this.fullText) return;

  // 🟢 ACHIEVED STATE (highest unlocked only)
  let achievedMessage = "";

  if (achievedTier) {
    achievedMessage = `🎉 Du har opnået ${achievedTier.label}.`;
  }

  if (nextTier) {
    const remaining = nextTier.amount - total;
    percentage = total / nextTier.amount;

    let nextMessage = "";

    // 🔥 CLOSE STATE (<100 kr)
    if (remaining < 100) {
      nextMessage = `🔥 Du er MEGET tæt på! Kun ${this.formatMoney(remaining)} fra ${nextTier.label}`;
    }
    // 🟠 NEAR STATE (<250 kr)
    else if (remaining <= 250) {
      nextMessage = `⚡ Kun ${this.formatMoney(remaining)} fra ${nextTier.label}`;
    }
    // 🟡 NORMAL STATE
    else {
      nextMessage = `Køb for ${this.formatMoney(remaining)} mere og få ${nextTier.label}`;
    }

    this.remainingText.style.display = 'block';
    this.fullText.style.display = 'none';

    this.remainingText.innerHTML =
      `${achievedMessage ? achievedMessage + "<br>" : ""}${nextMessage}`;

    // 🟢 VISUAL STATE CLASS
    this.setAttribute('data-state', remaining <= 100 ? 'close' : remaining <= 250 ? 'near' : 'normal');

  } else {
    // 🏁 MAX TIER
    this.setAttribute('data-state', 'max');

    this.remainingText.style.display = 'none';
    this.fullText.style.display = 'block';

    this.fullText.innerHTML =
      `🎉 Du har opnået max fordel: ${topTier.label}`;
  }

  this.style.setProperty('--percentage', Math.min(percentage || 0, 1));
}

    formatMoney(amount) {
      let format = window.theme?.settings?.money_with_currency_format || "{{amount}} kr";

      if (typeof formatMoney === "function") {
        return formatMoney(amount * 100, format);
      }

      return `${Math.round(amount)} kr`;
    }
  }

  customElements.define('free-shipping', FreeShipping);
}
